import { Color } from '../../pkg';

export enum FillType {
  None,
  Solid,
  Hatch,
  Cross,
}

export enum StrokeType {
  None,
  Solid,
  Dashed,
  Dotted,
}

export interface Style {
  fill_color: Color;
  fill_type: FillType;
  stroke_color: Color;
  stroke_type: StrokeType;
  text_size: number;
}
